import { handleActions } from 'redux-actions';
import { push, remove, clear } from '../actions/snackbar';

const defaultState = { snackBarMessages: [] };

export const selector = ({ snackbar }) => (snackbar);

const snackbarReducer = handleActions(
  {
    [push]: (state, { payload: { snackBarMessage } }) => {
      const existingIndex = state.snackBarMessages.findIndex((item) => item.key === snackBarMessage.key);
      const index = existingIndex !== -1 ? existingIndex : state.snackBarMessages.length;
      return {
        ...state,
        snackBarMessages: [
          ...state.snackBarMessages.slice(0, index),
          snackBarMessage,
          ...state.snackBarMessages.slice(index + 1),
        ],
      };
    },
    [remove]: (state, { payload }) => ({
      ...state,
      snackBarMessages: state.snackBarMessages.filter(
        ({ key }) => key !== payload.key,
      ),
    }),
    [clear]: (state) => ({
      ...state,
      snackBarMessages: [],
    }),
  },
  defaultState,
);

export default snackbarReducer;
